import React from "react";
import DashboardLayout from "../components/DashboardLayout";

const Dashboard = () => {
  return (
    <DashboardLayout>
      <h1>Dashboard</h1>
      <p>Dashboard working</p>

      <div className="cards">
        <div className="card">
          <h3>Projects</h3>
          <p>12</p>
        </div>

        <div className="card">
          <h3>Enquiries</h3>
          <p>8</p>
        </div>

        <div className="card">
          <h3>Builders</h3>
          <p>5</p>
        </div>

        <div className="card">
          <h3>Status</h3>
          <p>Active</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
